import input from '../input.vue'

 const commonInput = {
    install:function(Vue) {
        Vue.component('commonInput', input)
    }
}

// 导出该组件

export default commonInput